import { render } from "./ReviewCard.component.vue?vue&type=template&id=9beb8720"
import script from "./ReviewCard.component.vue?vue&type=script&lang=js"
export * from "./ReviewCard.component.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__